import { type FC } from "react";

import styled from "@emotion/styled";

const Wrapper = styled.span`
    margin: 0 8px;
`;

export const Pipe: FC = () => <Wrapper>|</Wrapper>;
